import React, { useState } from 'react';
import { indexWrapCss } from './css/Home.style';
import Header from "../layouts/header/Header";
import Footer from "../layouts/footer/Footer";
import usePageTitle from "../../hooks/usePageTitle";
import { css } from "@emotion/react";

const bannerCss = css`
    width: 100%;
    background: linear-gradient(135deg, #19CF7A 0%, #119B58 100%);
    padding: 80px 20px;
    text-align: center;
    color: white;
    font-family: 'Pretendard', sans-serif;
    
    h1 {
        font-size: 40px;
        font-weight: 800;
        margin-bottom: 16px;
    }
    
    p {
        font-size: 18px;
        opacity: 0.9;
        max-width: 600px;
        margin: 0 auto;
        line-height: 1.6;
    }
    
    @media (max-width: 768px) {
        padding: 50px 20px;
        h1 { font-size: 28px; }
        p { font-size: 14px; }
    }
`;

const contentCss = css`
    max-width: 1200px;
    margin: 0 auto;
    padding: 60px 20px;
    
    .intro-grid {
        display: grid;
        grid-template-cols: 1fr 1fr;
        gap: 40px;
        margin-bottom: 80px;
        
        @media (max-width: 768px) {
            grid-template-cols: 1fr;
        }
    }
    
    .intro-card {
        background: white;
        border: 1px solid #E5ECE8;
        border-radius: 20px;
        padding: 40px;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.03);
        
        h3 {
            font-size: 22px;
            font-weight: 700;
            color: #222;
            margin-bottom: 16px;
        }
        
        p {
            font-size: 15px;
            color: #666;
            line-height: 1.7;
        }
    }
`;

const IndependentPage: React.FC = () => {
    usePageTitle(
        "독립출판 | 작가님과 독자님의 소중한 만남, 북밋",
        "다양한 독립출판물을 북밋에서 만나 보세요!"
    );

    const [search, setSearch] = useState("");

    const onSearchHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    };

    return (
        <div css={indexWrapCss} className="min-w-[320px]">
            <Header
                onChange={onSearchHandler}
                searchValue={search}
                name="search"
                activeFlag="independent"
            />
            
            <section css={bannerCss}>
                <h1>독립출판</h1>
                <p>기존의 틀에서 벗어나, 작가만의 독창적인 색깔과 감성이 고스란히 담긴 다양한 독립출판물을 북밋에서 자유롭게 만나보세요.</p>
            </section>

            <main css={contentCss}>
                <div className="intro-grid">
                    <div className="intro-card">
                        <h3>✍️ 나만의 개성 있는 창작</h3>
                        <p>독립출판은 규격화된 출판 구조에서 벗어나 작가가 기획, 집필, 편집, 디자인을 주도하는 창작 방식입니다. 북밋은 이러한 독립출판 작가님들의 날것의 매력과 깊이 있는 메시지를 독자님들과 연결합니다.</p>
                    </div>
                    <div className="intro-card">
                        <h3>📚 작품 너머의 따뜻한 대화</h3>
                        <p>단순한 도서 구매를 넘어, 작가와 독자가 소통하고 마음을 나눌 수 있는 따뜻한 연대의 커뮤니티 공간이 제공됩니다. 작품의 비하인드 스토리와 작가의 가치관을 직접 들어보세요.</p>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default IndependentPage;
